/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_NicknameInputs */

const en_us2_clubs_field_nickname = /** @type {(inputs: Clubs_Field_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your nickname in the club`)
};

const pt_br2_clubs_field_nickname = /** @type {(inputs: Clubs_Field_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu apelido no clube`)
};

const es_419_clubs_field_nickname = /** @type {(inputs: Clubs_Field_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu apodo en el club`)
};

const pt_pt2_clubs_field_nickname = /** @type {(inputs: Clubs_Field_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua alcunha no clube`)
};

const fr_fr2_clubs_field_nickname = /** @type {(inputs: Clubs_Field_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton pseudo dans le club`)
};

const de_de2_clubs_field_nickname = /** @type {(inputs: Clubs_Field_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Spitzname im Club`)
};

const it_it2_clubs_field_nickname = /** @type {(inputs: Clubs_Field_NicknameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo soprannome nel club`)
};

/**
* | output |
* | --- |
* | "Your nickname in the club" |
*
* @param {Clubs_Field_NicknameInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_nickname = /** @type {((inputs?: Clubs_Field_NicknameInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_NicknameInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_nickname(inputs)
	if (locale === "es-419") return es_419_clubs_field_nickname(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_nickname(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_nickname(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_nickname(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_nickname(inputs)
	return en_us2_clubs_field_nickname(inputs)
});
export { clubs_field_nickname as "clubs.field_nickname" }